import { render, staticRenderFns } from "./OperatNatija.vue?vue&type=template&id=6108b34c"
import script from "./OperatNatija.vue?vue&type=script&lang=js"
export * from "./OperatNatija.vue?vue&type=script&lang=js"
import style0 from "./OperatNatija.vue?vue&type=style&index=0&id=6108b34c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports